/**
 * Intonation Tags
 *
 * Defines how different emotional tags affect voice synthesis parameters.
 * These modify the base voice settings to create expressive delivery.
 */

export interface IntonationSettings {
  stability: number;  // 0-1: Lower = more expressive, Higher = more consistent
  style: number;      // 0-1: How much style to apply
  speed: number;      // Playback speed multiplier
  volume?: number;    // 0-1: Volume multiplier (optional, defaults to 1.0)
}

export const INTONATION_TAGS: Record<string, IntonationSettings> = {
  // Emotional intonations
  sarcasm: {
    stability: 0.4,
    style: 0.6,
    speed: 0.95,
  },

  panic: {
    stability: 0.2,
    style: 0.8,
    speed: 1.35, // FAST!
  },

  whisper: {
    stability: 0.3,     // Lower for breathy variation
    style: 0.1,         // Minimal style
    speed: 0.75,        // Slower, more deliberate
    volume: 0.6,        // Quieter
  },

  dramatic: {
    stability: 0.3,
    style: 0.9,
    speed: 0.80, // Slow
  },

  deadpan: {
    stability: 0.99,    // Maximum consistency for monotone
    style: 0.0,         // Zero style/expression
    speed: 1.00,        // Normal speed
  },

  cheerful: {
    stability: 0.5,
    style: 0.5,
    speed: 1.15,
  },

  threatening: {
    stability: 0.35,
    style: 0.7,
    speed: 0.85,
  },

  exhausted: {
    stability: 0.6,
    style: 0.3,
    speed: 0.75,
  },

  excited: {
    stability: 0.3,
    style: 0.7,
    speed: 1.25,
  },

  nervous: {
    stability: 0.3,
    style: 0.5,
    speed: 1.10,
  },

  smug: {
    stability: 0.5,
    style: 0.6,
    speed: 0.90,
  },
};
